<template>
	<div class="go_back">
		<i class="icon_svg el-icon-arrow-left" @click="goBackOrToHome()"></i>
		<div class="title">{{ title }}</div>
	</div>
</template>

<script>

export default {
	name: 'NoData',

	props: {
		routerName: {
			type: String,
			default: ""
		},
		page_title: {
			type: String,
			default: ""
		},
		SuperiorName: {
			type: String,
			default: ""
		},
		// params: {
		// 	type: Object,
		// 	default: {}
		// },
	},
	data() {
		return {
			title: this.page_title ? this.page_title : ""
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		console.log(this.SuperiorName)
	},
  
	methods:{
		// 如果存在上一页，调用方法跳转
		goBackOrToHome(){
			const router = this.$router;
			let from = this.$store.state.pageNameList.from
			console.log(from)
			if(this.routerName){
			  this.go_to_router(this.routerName)
			}else if(this.SuperiorName && this.SuperiorName == 'search-user'){
			  this.go_to_router('home')
			}else{
			  // 有上一页，返回上一页// 尝试返回
			  this.$router.back();
			}
			let that = this
			// 监听路由变化
			const removeAfterEach = this.$router.afterEach((to, from) => {
				console.log(to)
				console.log(from)
				if (to.name !== from.name) {
					console.log('返回成功');
				} else {
					that.go_to_router('home')
					console.log('返回失败');
				}
				// 移除监听器，避免重复触发
				removeAfterEach();
			});
		},
		
		goBackOrToHome2() {
		   const router = this.$router;
			let from = this.$store.state.pageNameList.from
			console.log(from)
			if(this.routerName){
			  this.go_to_router(this.routerName)
			}else if(this.SuperiorName && this.SuperiorName == 'search-user'){
			  this.go_to_router('home')
			}else if (from && from.name) {
			  // 有上一页，返回上一页
			  this.go_to_router(from.name, from.params)
			} else {
			  // 没有上一页，导航到首页
			  this.go_to_router('home')
			}
			
			// this.$router.go(-1)
			
			// if (router.history.length > 1) {
			//   // 有上一页，返回上一页
			//   router.back();
			//   router.go(-1);
			// } else {
			//   // 没有上一页，导航到首页
			//   router.push({ name: 'home' });
			// }
		},
		
		go_to_router(name, params){
			this.$router.push({
				name: name,
				params: params ? params : {}
				// params: {
				// 	// page: this.params.page ? this.params.page : '',
				// 	// per_page: this.params.per_page ? this.params.per_page : ''
				// }
			})
		}
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.go_back{
		position: relative;
		width: 100%;
		height: 35px;
		display: flex;
		justify-content: center;
		.icon_svg{
			position: absolute;
			left: 0px;
			top: 0px;
			width: 35px;
			height: 35px;
			display: flex;
			align-items: center;
			font-size: 24px;
			cursor: pointer;
		}
		.title{
			width: calc(100% - 60px);
			height: 35px;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			font-size: 15px;
			font-weight: 600;
			cursor: default;
		}
	}
	
	@media screen and (min-width: 1024px) {
		
	}
	@media screen and (max-width: 1024px) {
		
	}
</style>
